webpackJsonp([9],{

/***/ "Zec3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return main; });

/**
 * Инициализация выбиратора.
 */
function main() {
    var path = window.location.pathname;
    if (/^\/choose\/apartment\/?$/.test(path)) {
        __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "DX/w"))
            .then(function (module) { return module.default(); });
    }
    else {
        __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "aQNE"))
            .then(function (module) { return module.default(); });
    }
}
/**
 * Module.
 */



/***/ })

});


// WEBPACK FOOTER //
// chunk-choose.9adc35209a82c650ed2b.js